import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

import { PRODUCT_CARDS_QUERY } from '#client/queries/productCards';

export function useProductCards(categories) {
  const { businessEntityUuid } = useBusinessEntity();

  const {
    data, errors, loading, refetch
  } = useQuery(PRODUCT_CARDS_QUERY, {
    noThrow: true,
    variables: {
      filter: {
        businessEntityUuid,
        categories
      },
      experiment: {
        businessCreditCardsProductCardVariation: 'chase_credit_card_ink_cash'
      }
    }
  });

  useError(errors);

  return {
    data: data?.productCards || { cards: [], categories: [] },
    error: errors?.[0],
    loading,
    refetch
  };
}
